enum ModalType {
  NewSegment = 'NEW_SEGMENT',
  ViewSegment = 'VIEW_SEGMENT',
}

export default ModalType;
